import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Product} from '../../../Models/Product';
import {Helper} from '../../../../helpers/helper.service';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {ProductService} from '../../../Services/product.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {LanguageService} from '../../../../translation/Services/language.service';
import {TranslationFormlyService, TranslationIdMap} from '../../../Services/translation.formly.service';
import {Package} from '../../../Models/Package';
import {Grid} from '../../../../shared/Models/grid';
import {LanguageModel} from '../../../../translation/translation.models';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {ModelService} from '../../../Services/model.service';
import {CountryService} from '../../../../translation/Services/Country.service';
import {DomSanitizer} from '@angular/platform-browser';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=Product.image' +
  '&config=[{"width":100,"height":100,"tag":"thumbnail"},{"width":300,"height":300,"tag":"small"}]&quality=75';

@Component({
  selector: 'app-manage-product',
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss']
})
export class ManageProductComponent implements OnInit {
  public classicBox;
  public lastValue = {product: new Product()};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public productId: number;
  public modalId: number;
  public translations = [];
  public isEdit = false;
  public modals = [];
  public languages: LanguageModel[] = [];
  public showModal = false;
  public packages: Package[] = [];
  public imageUrl = null;
  options: FormlyFormOptions = {};
  public productsGrid: Grid;
  private translationFields = ['name', 'description'];
  // D14/D16/D17: parallel {field: {locale: id}} lookup, see TranslationFormlyService.
  private translationIds: TranslationIdMap = {};
  private packageTranslationFields = ['namxe'];
  public languageMap = {};
  public isStock = false;
  @ViewChild('classicForm', {static: false}) child;
  @ViewChild('productsModal', {static: false}) productsModal = null;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('imageElement', {static: false}) imageElement: ElementRef;

  public uploader: FileUploader = new FileUploader({
    itemAlias: 'image',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });
  private target: any;
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public fileUploadId: number;
  private fileRemoveFileId = null;

  constructor(
    private languageService: LanguageService,
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private productService: ProductService,
    private modelService: ModelService,
    private auth: AuthenticationService,
    private translationFormlyService: TranslationFormlyService,
    private countryService: CountryService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });

    this.modalId = this.route.snapshot.params['modelId'];

    this.productService.getModals().subscribe((resp) => {
      const respItem = resp.data;
      respItem.map((value) => {
        this.modals.push({
          label: value.name,
          value: value.id
        });
      });
      this.countryService.getCountriesWithVats().subscribe((items) => {
        const countries = items.data;

        this.languageService.list().subscribe(lang_resp => {
          this.languages = lang_resp.languages;
          this.languages.forEach(lang => {
            this.languageMap[lang.locale] = lang.locale;
          });

          this.route.params.subscribe(params => {
            new Promise((resolve, reject) => {
              if (Helper.isDefined(params['id'])) {
                this.productId = params['id'];
                this.isEdit = true;
                this.productService.getProductItem(this.productId).subscribe(resp => {
                  if (resp.image) {
                    this.imageUrl = environment.absolutePath + '/' + resp.image.fileManagers.thumbnail.fullPath;
                  }
                  if (typeof resp.models[0] !== 'undefined') {
                    resp.models = resp.models[0].id;
                  }
                  if (resp.manageStock) {
                    this.isStock = true;
                  }
                  resolve(resp);
                });
              } else {
                resolve(new Product());
              }
            }).then(product => {
              this.lastValue.product = (<Product>product);
            }).then(() => {
              this.translationIds = TranslationFormlyService.buildTranslationIdMap(this.lastValue.product.translations);
              this.lastValue.product.translations = TranslationFormlyService.prepareTranslationFields(
                this.translationFields, this.lastValue.product.translations, this.languages
              );
            }).then(() => {
              this.classicBox = <FormlyFieldConfig>[];
              this.classicBox.push(
                {
                  className: 'section-label',
                  template: '<div><strong>' + this.translate.instant('doctrine.product.product_name') + '</strong></div><hr />',
                });
              Object.keys(this.lastValue.product.translations).forEach((field) => {
                const row = {
                  fieldGroupClassName: 'row',
                  key: 'product.translations',
                  fieldGroup: []
                };
                Object.entries(this.lastValue.product.translations[field]).forEach((t) => {
                  let requiredFild = false;
                  if (field === 'name') {
                    requiredFild = true;
                  }
                  row.fieldGroup.push(
                    {
                      className: 'col-6 ',
                      type: 'input',
                      key: field + '[' + t[0] + ']',
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.' + field) + ' (' + this.languageMap[t[0]] + ')',
                        required: requiredFild,
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    }
                  );
                });
                this.classicBox.push(row);
              });
              this.classicBox.push(
                {
                  className: 'section-label',
                  template: '<div><strong>' + this.translate.instant('doctrine.product.codes') + '</strong></div><hr />',
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  fieldGroup: [
                    {
                      className: 'col-6 ',
                      type: 'input',
                      key: 'number',
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.number'),
                        required: true,
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                    {
                      className: 'col-6 ',
                      type: 'input',
                      key: 'factoryCode',
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.factory_code'),
                        required: false,
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                  ],
                },
                {
                  className: 'section-label',
                  template: '<div><strong>' + this.translate.instant('doctrine.product.default_price') + '</strong></div><hr />',
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  fieldGroup: [
                    {
                      className: 'col-3 ',
                      type: 'input',
                      key: 'dealerPrice',
                      // Per-m² products price by the square metre — contract product-configuration.md
                      expressionProperties: {
                        'templateOptions.label': () => this.translate.instant('admin.product.add.dealer_price')
                          + (Product.isRug(this.lastValue.product) ? ' ' + this.translate.instant('doctrine.product.per_square_meter_suffix') : ''),
                      },
                      templateOptions: {
                        label: this.translate.instant('admin.product.add.dealer_price'),
                        addonLeft: {
                          text: this.translate.instant('global.currency_sign'),
                        },
                        required: true,
                        pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                    {
                      className: 'col-3 ',
                      type: 'input',
                      key: 'customerPrice',
                      // Per-m² products price by the square metre — contract product-configuration.md
                      expressionProperties: {
                        'templateOptions.label': () => this.translate.instant('admin.product.add.customer_price')
                          + (Product.isRug(this.lastValue.product) ? ' ' + this.translate.instant('doctrine.product.per_square_meter_suffix') : ''),
                      },
                      templateOptions: {
                        label: this.translate.instant('admin.product.add.customer_price'),
                        addonLeft: {
                          text: this.translate.instant('global.currency_sign'),
                        },
                        required: true,
                        pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                  ],
                },
                {
                  className: 'section-label',
                  template: '<div><strong><strong>' + this.translate.instant('doctrine.product.other') + '</strong></strong></div><hr />',
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  fieldGroup: [
                    {

                      className: 'col-3 ',
                      type: 'ng-select',
                      key: 'models',
                      defaultValue: this.modalId ? [+this.modalId] : false,
                      templateOptions: {
                        multiple: false,
                        required: true,
                        label: this.translate.instant('doctrine.model.model'),
                        options: this.modals,
                      },
                    },
                    {
                      className: 'col-3 ',
                      type: 'ng-select',
                      key: 'status',
                      defaultValue: true,
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.status'),
                        required: true,
                        options: [
                          {label: this.translate.instant('global.active'), value: true},
                          {label: this.translate.instant('global.inactive'), value: false},
                        ],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  fieldGroup: [
                    {
                      key: 'hasFabric',
                      type: 'checkbox',
                      className: 'col-3 pt-4',
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.has_fabric'),
                        required: false
                      }
                    },
                    {
                      className: 'col-3 pt-4',
                      type: 'checkbox',
                      key: 'inCSV',
                      hideExpression: (model) => !this.isStock,
                      defaultValue: true,
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.upload_in_csv'),
                        required: false,
                      },
                    },
                    {
                      className: 'col-3 pt-4',
                      type: 'checkbox',
                      key: 'excludeInPackagingLabel',
                      defaultValue: false,
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.exclude_in_packaging_label'),
                        required: false,
                      },
                    },
                  ]
                },
                {
                  className: 'section-label',
                  template: '<div><strong>' + this.translate.instant('doctrine.product.carpet_sizing') + '</strong></div><hr />',
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  fieldGroup: [
                    {
                      className: 'col-3 ',
                      type: 'ng-select',
                      key: 'pricingMode',
                      defaultValue: Product.PRICING_MODE_PER_UNIT,
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.pricing_mode'),
                        required: true,
                        options: [
                          {label: this.translate.instant('doctrine.product.pricing_mode_per_unit'), value: Product.PRICING_MODE_PER_UNIT},
                          {
                            label: this.translate.instant('doctrine.product.pricing_mode_per_square_meter'),
                            value: Product.PRICING_MODE_PER_SQUARE_METER
                          },
                        ],
                      },
                    },
                    {
                      className: 'col-3 ',
                      type: 'ng-select',
                      key: 'sizingMode',
                      defaultValue: Product.SIZING_MODE_FIXED,
                      // Only meaningful for a per-m² product — FR-002
                      hideExpression: () => !Product.isRug(this.lastValue.product),
                      templateOptions: {
                        label: this.translate.instant('doctrine.product.sizing_mode'),
                        required: true,
                        options: [
                          {label: this.translate.instant('doctrine.product.sizing_mode_fixed'), value: Product.SIZING_MODE_FIXED},
                          {label: this.translate.instant('doctrine.product.sizing_mode_custom'), value: Product.SIZING_MODE_CUSTOM},
                        ],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'product',
                  // Shown for any per-m² product, not only custom-sized ones: formly clears a
                  // hidden field's value, so narrowing this further would silently drop limits
                  // a back-office user had already entered — FR-005
                  hideExpression: () => !Product.isRug(this.lastValue.product),
                  fieldGroup: [
                    ['minWidthCm', 'min_width_cm'], ['maxWidthCm', 'max_width_cm'],
                    ['minLengthCm', 'min_length_cm'], ['maxLengthCm', 'max_length_cm'],
                  ].map(([key, labelKey]) => ({
                    className: 'col-3 ',
                    type: 'input',
                    key: key,
                    templateOptions: {
                      type: 'number',
                      label: this.translate.instant('doctrine.product.' + labelKey),
                      required: false,
                      min: 1,
                      pattern: '^\\d{1,5}$',
                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        min: this.translate.instant('errors.invalid'),
                      },
                    },
                  })),
                }
              );
            });
          });
        });
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  redirectToList() {

    if (this.modalId) {
      this.router.navigateByUrl('/back-office/model/' + this.modalId + '/show');
    } else {
      window.history.back();
    }
  }

  submitItem(isEdit) {
    const product = JSON.parse(JSON.stringify(this.lastValue));
    delete product.product.id;
    delete product.product.parentPosition;
    delete product.product.deleted;
    delete product.product.ownStock;
    delete product.product.productCollies;
    delete product.product.optionProducts;
    delete product.product.partProducts;
    product.product.translations = TranslationFormlyService.reorganizeTranslations(
      this.translationFields, product.product.translations, this.translationIds
    );
    const removeUselessPropertiesToSave = [
      'id', 'name', 'packages', 'hasProduct', 'stock', 'tmsStock', 'EANCode', 'productProperties',
      'manageStock', 'position', 'lowStockTrigger', 'emailStockTrigger', 'description', 'productSizes'
    ];
    removeUselessPropertiesToSave.forEach(prop => delete product.product[prop]);
    new Promise((resolve) => {
      if (this.uploader.queue.length === 0) {
        return resolve(true);
      }
      this.uploadFile(() => {
        resolve(true);
      });
    }).then(() => {
      if ((null != this.fileUploadId) && isEdit) {
        product.product.image = this.fileUploadId;
      } else {
        if (this.lastValue.product.image) {
          product.product.image = this.lastValue.product.image.id;
        } else {
          product.product.image = null;
        }
      }
      product.product.models = [product.product.models];
      if (this.fileRemoveFileId !== null) {
        this.productService.removeImage(this.fileRemoveFileId, this.productId).subscribe((deleteResp) => {
          this.isUploading = false;
          this.productService.manageProduct(product, this.isEdit, this.productId).subscribe((resp) => {
            if (this.modalId) {
              this.router.navigateByUrl('/back-office/model/' + this.modalId + '/show');
            } else {
              this.router.navigateByUrl('/back-office/product/overview');
            }
          });
        });
      } else {
        this.productService.manageProduct(product, this.isEdit, this.productId).subscribe((resp) => {
          if (this.modalId) {
            this.router.navigateByUrl('/back-office/model/' + this.modalId + '/show');
          } else {
            window.history.back();
          }
        });
      }
    });
  }

  removeImage(file, ProductId = null) {
    this.isUploading = true;
    if (file && file.hasOwnProperty('id')) {
      this.fileRemoveFileId = file.id;
    }
    this.imageUrl = null;
    this.isUploading = false;
    this.lastValue.product.image = null;
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
  }

  uploadFile(cb) {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        const res = JSON.parse(response);
        this.imageUrl = environment.absolutePath + '/' + res.fullPath;
        this.lastValue.product.image = res;
        this.fileUploadId = res.id;
        cb();
      }
    };
  }

  changeImage(event) {
    this.imageUrl = null;
    this.isUploading = false;
    this.uploader.clearQueue();
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    element.click();
  }

  fileChange($event: Event) {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      this.imageUrl = reader.result;
    };
    if (this.uploader.queue[0]._file) {
      return reader.readAsDataURL(this.uploader.queue[0]._file);
    }
  }
}
